import NextLink, { LinkProps } from "next/link"
import React from "react"
import styled from "styled-components"

interface Props {
  href: LinkProps["href"]
  children: string | React.ReactNode
  dynamicRoutePath?: string
  target?: string
  className?: string
  rel?: string
}

const Link = ({ href, children, dynamicRoutePath, target, className, rel }: Props) => {
  if (
    typeof href === "object" ||
    (!href.startsWith("http") &&
      // ページ内リンクのときは通常のaタグを返すようにする
      !(typeof href === "string" && href.startsWith("#")))
  ) {
    return (
      <NextLink href={href} as={dynamicRoutePath} passHref>
        <StyledLink className={className}>{children}</StyledLink>
      </NextLink>
    )
  } else {
    return (
      <StyledLink href={href} target={target} className={className} rel={rel}>
        {children}
      </StyledLink>
    )
  }
}

const StyledLink = styled.a`
  color: inherit;
  text-decoration: none;
`

export default Link
